module.exports = __webpack_public_path__ + "static/media/Theme6.72c6df50.png";